import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Redirects authenticated users who lack the required role away from the
 * wrapped route. Intended for beta / feature-flagged screens.
 *
 * Assumes it's rendered inside <ProtectedRoute>, so auth is already resolved.
 */
const RoleGate = ({ role, redirectTo = '/snipe-feed', children }) => {
    const { hasRole, isLoading } = useAuth();

    if (isLoading) return null;
    if (!hasRole(role)) return <Navigate to={redirectTo} replace />;

    return children;
};

export default RoleGate;
